export interface ResizeInfo {
  top: boolean;
  right: boolean;
  bottom: boolean;
  left: boolean;
}

export type WithResizeInfo<T extends HTMLElement> = T & { dResize?: ResizeInfo };

export function getResize({ clientX: x, clientY: y }: PointerEvent, element: HTMLElement, margin: number): ResizeInfo {
  const rect = element.getBoundingClientRect();
  const delta = {
    top: Math.abs(rect.top - y),
    right: Math.abs(rect.right - x),
    bottom: Math.abs(rect.bottom - y),
    left: Math.abs(rect.left - x),
  };
  return {
    top: delta.top <= margin,
    right: delta.right <= margin,
    bottom: delta.bottom <= margin,
    left: delta.left <= margin,
  };
}
